import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { navigationApiRef } from './api';
import { redirectRouteRef } from './routes';
import { NavigationClient } from '@appfolio/backstage-plugin-navigation-common';

export const navigationPlugin = createPlugin({
  id: 'appfolio-navigation',
  apis: [
    createApiFactory({
      api: navigationApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new NavigationClient({ discoveryApi, fetchApi }),
    }),
  ],
  routes: {
    redirect: redirectRouteRef,
  },
});

export const Routes = navigationPlugin.provide(
  createComponentExtension({
    name: 'Routes',
    component: {
      lazy: () => import('./components/Routes').then(m => m.Routes),
    },
  }),
);
